import 'slick-carousel/slick/slick'

export default class RelatedPostsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-related-posts-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        }

    }

};

new RelatedPostsSlider();